<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>
<script>
  export default {
    components: {},
    computed: {
      layout() {
        return this.$route.meta.layout ? `${this.$route.meta.layout}-layout` : 'default-layout'
      }
    }
  }
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Roboto', sans-serif;
}

a {
  text-decoration: none !important;
  color: initial !important;
}
p {
  margin-bottom: 0 !important;
}
.text_danger {
  display: block;
  margin-top: 3px;
  color: red;
  font-size: 13px;
}
.is-invalid {
  color: red;
  box-shadow: 0 1px 8px #dd5050;
}
.cursor_pointer {
  cursor: pointer;
}
</style>
